// Module
var code = "<div class=\"ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle\" ng-class=\"::{'is-negative-charge' : row.entity.isChargeNegative}\" ng-bind=\"::row.entity.charge | invEmpty\"></div>\n</div>\n";
// Exports
module.exports = code;